import { Page } from "@/components/Page";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/Marquee";
import { ConciergeCard } from "@/components/home/ConciergeCard";
import { Values } from "@/components/home/Values";
import { LifestyleSplit } from "@/components/home/LifestyleSplit";
import { Services } from "@/components/home/Services";
import { Manifesto } from "@/components/home/Manifesto";
import { CtaStrip } from "@/components/home/CtaStrip";

export default function Home() {
  return (
    <Page testId="home-page">
      <Hero />
      <Marquee />
      <ConciergeCard />
      <Values />
      <LifestyleSplit />
      <Services />
      <Manifesto />
      <CtaStrip />
    </Page>
  );
}
